import { AnalyticsService, CommonAnalyticsModalName } from '@ui-common/analytics'
import { useEffect, useRef } from 'react'

import { debugLog } from '../utils'

export const useSendPageViewEvent = <TPageEvent, TCustomEventName>(
  analyticsService: AnalyticsService<TPageEvent, TCustomEventName, CommonAnalyticsModalName>,
  name: TPageEvent,
  /** to support digili sending own events with state transitions */
  shouldNotSendPageViews?: boolean,
): void => {
  const lastSentPage = useRef<TPageEvent | null>(null)

  useEffect(() => {
    debugLog('Send analytics page view event: ', name)
    // Avoid sending same page view multiple times in a row (React StrictMode)
    if (name && name !== lastSentPage.current && !shouldNotSendPageViews) {
      analyticsService.sendPageViewEvent(name)
      lastSentPage.current = name
    }
  }, [analyticsService, name, shouldNotSendPageViews])
}
